export const parseTextParams = (textValue, paramObject) => {
    return Object.keys(paramObject).reduce((text, key) => text.replace(`$\{${key}}`, paramObject[key]), textValue);
};
export const createFieldId = (label) => {
    return label.replaceAll(' ', '');
};
//# sourceMappingURL=TextUtil.js.map